import QueryView from './QueryView';

export default QueryView;
